// src/services/firestoreWrite.js — every browser-side Firestore WRITE goes
// through here. adr-firestore-identity.md step a2.
//
// Same names and signatures as 'firebase/firestore'. Services import their
// write functions from this module instead; reads and onSnapshot are untouched.
//
// When the member's Firestore identity is already in place (the normal case)
// the call goes straight through, synchronously — no extra microtask, so
// writes fired from beforeunload/pagehide (e.g. presence cleanup) behave
// exactly as before. Only a write attempted in the first moment on a device,
// before the background hand-over completes, waits for it (capped; see
// firebaseAuth.js). Optimistic UI already renders before writes resolve, so
// that wait is never visible.

import {
    setDoc as fsSetDoc,
    addDoc as fsAddDoc,
    updateDoc as fsUpdateDoc,
    deleteDoc as fsDeleteDoc,
    runTransaction as fsRunTransaction,
    writeBatch as fsWriteBatch,
} from 'firebase/firestore';
import { isReadyNow, firebaseAuthReady } from './firebaseAuth';

function gated(fn) {
    return (...args) => (isReadyNow() ? fn(...args) : firebaseAuthReady().then(() => fn(...args)));
}

export const setDoc = gated(fsSetDoc);
export const addDoc = gated(fsAddDoc);
export const updateDoc = gated(fsUpdateDoc);
export const deleteDoc = gated(fsDeleteDoc);
export const runTransaction = gated(fsRunTransaction);

// writeBatch() itself is synchronous (it only builds the batch); gate commit().
export function writeBatch(db) {
    const batch = fsWriteBatch(db);
    const commit = batch.commit.bind(batch);
    batch.commit = gated(commit);
    return batch;
}
